var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.172 1.029L1.13 9.072a1.313 1.313 0 000 1.856l8.043 8.043a1.312 1.312 0 001.856 0l8.044-8.043a1.312 1.312 0 000-1.856l-8.043-8.043a1.312 1.312 0 00-1.857 0z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.871 8.971L36.828.928a1.312 1.312 0 00-1.857 0l-8.043 8.043a1.313 1.313 0 000 1.857l8.043 8.043a1.312 1.312 0 001.857 0l8.043-8.043a1.313 1.313 0 000-1.857z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1.667a.5.5 0 001 0h-1zM23.5 5a.5.5 0 00-1 0h1zm-1 3.333a.5.5 0 001 0h-1zm1 3.334a.5.5 0 10-1 0h1zM22.5 15a.5.5 0 001 0h-1zm1 3.333a.5.5 0 00-1 0h1zM22.5 0v1.667h1V0h-1zm0 5v3.333h1V5h-1zm0 6.667V15h1v-3.333h-1zm0 6.666V20h1v-1.667h-1z",
    fill: "currentColor"
  })));
}
export default SvgCopyTheme;